import { render, staticRenderFns } from "./BecomeSupplierLink.vue?vue&type=template&id=dedc3a40&scoped=true&"
import script from "./BecomeSupplierLink.vue?vue&type=script&lang=js&"
export * from "./BecomeSupplierLink.vue?vue&type=script&lang=js&"
import style0 from "./BecomeSupplierLink.vue?vue&type=style&index=0&id=dedc3a40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedc3a40",
  null
  
)

export default component.exports